export default __webpack_public_path__ + "static/media/line-v-20.600e2a33.png";